import { List } from '@chakra-ui/react';
import styled from '@emotion/styled';

const DropDownList = styled(List)`
  transition: box-shadow 0.2s ease-in-out;
  .dropdown-list {
    display: none;
    opacity: 0;
    z-index: auto;
  }
  &:hover .title {
    color: #025285;
  }
  .element:hover {
    color: #025285;
  }
  &:hover {
    border-radius: 29px;
    background-color: #fafafa;
    box-shadow: 0 3px 15px 0 rgba(0, 0, 0, 0.1);
    z-index: 1000;
  }
  &:hover .dropdown-list {
    display: flex;
    opacity: 1;
  }
`;

export default DropDownList;
